<template>
    <v-container
        fluid
        :class="{
            'container-full-bg-gray': true,
            'pa-0': is_mobile,
            'rounded-mobile': is_mobile
        }"
    >
    <!-- company.confg auto_send_to_verifactu sii_opt_checked spanish_territory_opt_checked no_application_checked -->
        <div v-if="invoice_list_component && !invoice_list_component.hasAccessToFacturaE()">
            <AccessDeniedToFacturaEPopup
                :companydb_id="companydb_id"
            />
        </div>
        <v-snackbar
            v-if="screen_data"
            v-model="screen_data.snackbar.isVisible"
            :color="screen_data.snackbar.color"
            :timeout="screen_data.snackbar.timeout"
            :style="is_mobile && { marginTop: '-50%' }"
        >
            {{ screen_data.snackbar.text }}
        </v-snackbar>

        <v-dialog v-model="delete_pop_up" persistent max-width="500">
            <v-card>
                <v-card-title>
                    <span class="primary_blue--text">Eliminar {{screen_data.invoiceableTypeName.toLowerCase() + 's'}}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <p class="text-subtitle-1 mt-4">
                        Se eliminarán permanentemente  {{ screen_data.selectedItems.length.toString() }} {{screen_data.invoiceableTypeName.toLowerCase()}}(s)
                    </p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="delete_pop_up = false" class="action__btn">Cancelar</v-btn>
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="deleteSelectedItems()"
                    >
                    Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="sign_to_draft_popup" persistent max-width="500">
            <v-card>
                <v-card-title>
                    <span class="primary_blue--text">Pasar a borrador</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <p class="text-subtitle-1 mt-4 mb-4">
                        ¿Está seguro de que desea pasar {{ screen_data.selectedItems.length.toString() }} {{screen_data.invoiceableTypeName.toLowerCase()}}(s) a borrador?
                    </p>
                    <v-checkbox
                        v-model="delete_invoice_number"
                        label="Borrar el número de factura"
                        hide-details
                    ></v-checkbox>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="sign_to_draft_popup = false" class="action__btn">Cancelar</v-btn>
                    <v-btn
                        color="var(--v-primary_blue-base)"
                        class="white--text action__btn"
                        @click="confirmSignToDraft()"
                    >
                    Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.mergeDeliveryNotesDialog" max-width="500" persistent>
            <v-card>
                <v-card-title>
                    <span class="primary_blue--text">Facturar albaranes</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="px-8 py-5">
                    <v-row>
                        <v-col>
                            <div>
                                <v-select
                                    v-model="screen_data.mergeDeliveryNotesMode"
                                    :items="screen_data.mergeDeliveryNotesModes"
                                    label="Modo de facturación"
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                                <div v-if="screen_data.mergeDeliveryNotesMode === 'merge'" class="hint-text">
                                    <strong>Los albaranes seleccionados se agruparán por secuencia y cliente.</strong>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.mergeDeliveryNotesDialog = false" class="action__btn">Cancelar</v-btn>
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn"
                        :disabled="screen_data.mergeDeliveryNotesMode == ''"
                        @click="call_generate()"
                    >
                    Crear
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="conf_pop_up" max-width="1100" content-class="config__dialog">
            <!-- <SequenceConfig :sequence="screen_data.sequence" @save-seq="saveSequence"
            @cancel="cancel_conf_seq"></SequenceConfig> -->
            <EInvoiceConfig v-if="conf_pop_up && configurationReady" class="ma-0 pa-0" :configuration="screen_data.configuration" :templates="screen_data.templates" @save-config="saveConfig" :invoiceableType="screen_data.invoiceableType"
            @cancel="calcelSaveConfig()"></EInvoiceConfig>
        </v-dialog>

        <v-dialog v-model="screen_data.createRectificativeDialog" v-if="screen_data.new_invoice" max-width="600" class="ma-0 pa-0">
            <v-card>
                <v-card-title class="justify-center">
                    <span class="primary_blue--text text-h6">Crear factura</span>
                </v-card-title>

                <v-divider />

                <v-card-text class="pa-4">
                    <template v-if="screen_data.selectedItems.length === 1">
                    <p class="text-subtitle-1 mb-4 text-center">
                        ¿Estás seguro de que quieres crear una factura rectificativa de la factura seleccionada?
                    </p>
                    <p class="text-center">
                        <strong>Factura seleccionada:</strong> {{ screen_data.selectedItems[0].invoice_number }}
                    </p>
                    </template>

                    <template v-else>
                    <v-row dense>
                        <v-col cols="12">
                        <label>Número de la factura a rectificar</label>
                        <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="screen_data.externalRecInvNumber"
                        />
                        </v-col>
                        <v-col cols="12">
                        <label class="text-no-wrap">Fecha de la factura a rectificar</label>
                        <v-menu
                            ref="invoiceStartDate"
                            v-model="dateVisible"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                outlined
                                dense
                                hide-details
                                :value="formattedDate(screen_data.externalRecInvDate)"
                                v-on="on"
                            />
                            </template>
                            <v-date-picker
                            v-model="screen_data.externalRecInvDate"
                            no-title
                            @input="handleDateChange()"
                            />
                        </v-menu>
                        </v-col>
                    </v-row>
                    </template>
                </v-card-text>

                <v-card-actions class="acction_btns">
                    <v-spacer />
                    <v-btn outlined @click="screen_data.createRectificativeDialog = false" class="action__btn">
                    Cancelar
                    </v-btn>
                    <v-btn
                    color="primary_blue"
                    class="white--text action__btn"
                    :disabled="!canCreate"
                    @click="tryCreate()"
                    >
                    Crear
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- PopUp Advertencia-->
        <v-dialog v-model="screen_data.showPopUp" v-if="screen_data.showPopUp" max-width="700">
            <v-card>
                <v-card-title class="d-flex align-center primary_blue white--text">
                    <span class="font-weight-bold">Advertencia</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closePopup" color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-4">
                    <p v-html="screen_data.messagePopUp"></p>
                </v-card-text>
            </v-card>
        </v-dialog >

        <!-- PopUp Éxito -->
        <v-dialog v-model="screen_data.showPopUpSuccessful" v-if="screen_data.showPopUpSuccessful" max-width="700">
            <v-card>
                <v-card-title class="d-flex align-center primary_blue white--text">
                    <!-- <span class="font-weight-bold">Éxito</span> -->
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closePopupSuccessful" color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-4">
                    <p v-html="screen_data.messagePopUpSuccessful"></p>
                </v-card-text>
            </v-card>
        </v-dialog >

         <!-- PopUp Due Date Fecha de Vencimiento -->
        <v-dialog v-model="screen_data.showPopUpDueDate" v-if="screen_data.showPopUpDueDate" max-width="400">
            <v-card :style="{ overflow: 'visible', height: 'auto', minHeight: '100px' }">
                <v-card-title class="justify-center d-flex align-center">
                    <span class="primary_blue--text text-h6">
                        <span v-if="this.screen_data.massiveSign">Firmar y Emitir</span>
                        <span v-else>Añadir Fecha de Vencimiento</span>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closePopupDueDate" color="primary_blue">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider />
                
                <v-card-text class="pl-14 pr-14 pa-4" >
                    <p v-html="screen_data.messagePopUpDueDate"></p>                    
                    <AppDateField
                        :label="'Fecha vencimiento'"
                        :background_color="'white'"
                        v-model="screen_data.dueDate"
                    />
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined class="action__btn" @click=closePopupDueDate>
                        Cancelar
                    </v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="massiveDueDate()" :disabled="!screen_data.dueDate">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog >

        <!-- PopUp Selección PaymentMeans -->
         <v-dialog v-model="screen_data.showPopUpPaymentMeans" v-if="screen_data.showPopUpPaymentMeans" max-width="400">
            <v-card>
                <v-card-title class="justify-center d-flex align-center">
                    <span class="primary_blue--text text-h6">
                        <span v-if="this.screen_data.massiveSign">Firmar y Emitir</span>
                        <span v-else>Añadir método de pago</span>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closePopUpPaymentMeans" color="primary_blue">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-4 pl-14 pr-14">
                    <p v-html="screen_data.messagePopUpPaymentMeans"></p>
                    <v-select
                        v-model="screen_data.paymentMeans"
                        :items="screen_data.paymentMeansOptions"
                        item-value="value"
                        item-text="text"
                        label="Selecciona el método de pago"
                        outlined
                        dense
                        hide-details
                    ></v-select>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined class="action__btn" @click=closePopUpPaymentMeans>
                        Cancelar
                    </v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="massivePaymentMeans()" :disabled="!screen_data.paymentMeans || screen_data.paymentMeans=='00' ">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog >

        <!-- PopUp Selección PaymentMeans Y DueDate -->
         <v-dialog v-model="screen_data.showPopUpPaymentMeansDueDate" v-if="screen_data.showPopUpPaymentMeansDueDate" max-width="700">
            <v-card>
                <v-card-title class="d-flex align-center primary_blue white--text">
                    <span class="font-weight-bold" v-if="this.screen_data.massiveSign">Firmar y Emitir</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closePopUpPaymentMeansDueDate" color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pl-14 pr-14 pa-4">
                    <p v-html="screen_data.messagePopUpPaymentMeansDueDate"></p>
                    <!-- Campo Método de pago -->
                    <v-select
                        v-model="screen_data.paymentMeans"
                        :items="screen_data.paymentMeansOptions"
                        item-value="value"
                        item-text="text"
                        label="Selecciona el método de pago"
                        outlined
                        dense
                        hide-details
                    ></v-select>
                    <!-- Campo Fecha de vencimiento -->
                    <AppDateField
                        :label="'Fecha vencimiento'"
                        :background_color="'white'"
                        v-model="screen_data.dueDate"
                        class="mb-6"
                    />
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined class="action__btn" @click=closePopUpPaymentMeansDueDate>
                        Cancelar
                    </v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="massivePaymentMeansDueDate()" :disabled="!screen_data.dueDate || !screen_data.paymentMeans || screen_data.paymentMeans=='00' ">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog >

        <!-- PopUp Alerta - Metodo de pago diferente de 'Recibo Domiciliado' ("02") para generar remesa -->
        <v-dialog v-model="screen_data.showRemittancePaymentNo02Alert" v-if="screen_data.showRemittancePaymentNo02Alert" max-width="700">
            <v-card>
                <v-card-title class="d-flex align-center primary_blue white--text">
                    <span class="font-weight-bold">Advertencia</span>
                    <v-icon color="yellow" class="mx-2">mdi-alert</v-icon>
                </v-card-title>
                <v-card-text class="pa-4">
                    <p>Se han seleccionado facturas con método de pago distinto a '<b>Recibo Domiciliado</b>.'</p>
                    <p><b>¿Estás seguro de que quieres continuar?</b></p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined class="action__btn" @click="screen_data.showRemittancePaymentNo02Alert = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="closeShowRemittancePaymentNo02Alert">
                        Generar Remesa
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog >

        <!-- PopUp Generación Remesa <- Debería hacer un refactor y quitarlo, pues es el pop up puede ser genérico.-->
        <v-dialog v-model="screen_data.showGenerateRemittancePopUp" v-if="screen_data.showGenerateRemittancePopUp" max-width="700">
            <v-card>
                <v-card-title class="d-flex align-center primary_blue white--text">
                    <span class="font-weight-bold">Advertencia</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeShowGenerateRemittancePopup" color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-4">
                    <p v-html="screen_data.messageShowGenerateRemittancePopUp"></p>
                </v-card-text>
            </v-card>
        </v-dialog >

        <!-- PopUp selección de tipo de remesa -->
        <v-dialog v-model="screen_data.showRemittanceTypePopUp" v-if="screen_data.showRemittanceTypePopUp" max-width="500">
            <v-card>
                <v-card-title class="justify-center">
                    <span class="primary_blue--text text-h6">Generar remesa</span>
                </v-card-title>

                <v-divider />

                <v-card-text class="pa-4">
                    <v-select
                        v-model="screen_data.selectedRemittanceType"
                        :items="screen_data.remittanceTypes"
                        item-value="value"
                        item-text="text"
                        label="Selecciona el tipo de remesa"
                        outlined
                        dense
                        hide-details
                    ></v-select>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined class="action__btn" @click="screen_data.showRemittanceTypePopUp = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="generateRemittance" :disabled="!screen_data.selectedRemittanceType">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>

        <PopUpEmisor
            ref="popUpEmisor"
            :companydb-id="companydb_id"
        />

        <v-card width="100%" :class="{'rounded-10': true, 'pa-0': is_mobile}">

            <v-card-title :class="!is_mobile ? 'invoiceable-title' : 'invoiceable-title-mobile'">

                <div id="header-menu-anchor" v-if="got_feature('feature_budgets')">

                    <div class="primary_blue--text header__menu__transaparent__btn" @click="screen_data.menuList = !screen_data.menuList"> Listado de
                        <span v-if="['budget', 'invoice', 'proforma', 'ticket'].includes(screen_data.invoiceableType)">{{screen_data.invoiceableTypeName + 's'}}</span>
                        <span v-else> Albaranes</span>
                        <v-icon v-if="screen_data.menuList" color="primary_blue">mdi-menu-up</v-icon>
                        <v-icon v-else color="primary_blue">mdi-menu-down</v-icon>
                    </div>

                    <v-divider v-if="is_mobile" class="mb-4"></v-divider>

                    <!-- Botón elección para pasar a Listado de facturas, presupuestos, albaranes, proformas-->
                    <v-menu
                        bottom
                        v-model="screen_data.menuList"
                        transition="scale-transition"
                        offset-y
                        content-class="header__menu__transaparent"
                        attach="#header-menu-anchor"
                    >
                        <v-list class="header__menu__options__transaparent">
                            <template v-for="option in screen_data.redirectOptions">
                                <v-list-item
                                    class="header__menu__transaparent__btn"
                                    :class="{ 'hover-state': $router.currentRoute.name === option.value }"
                                    @click="redirectToList(option.value)"
                                    >
                                    <span>{{option.text}}</span>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </div>

                <div v-else class="primary_blue--text"> Listado de
                    <span v-if="['budget', 'invoice', 'proforma', 'ticket'].includes(screen_data.invoiceableType)">{{screen_data.invoiceableTypeName + 's'}}</span>
                    <span v-else> Albaranes</span>
                </div>

                <div class="invoiceable-title_right-section">

                    <!-- Pending Email Invoices Warning -->
                    <v-tooltip top v-if="pendingEmailInvoices.length > 0">
                        <template v-slot:activator="{ on, attrs }">
                            <div @click="showPendingEmailDialog = true" class="clickable-icon" v-bind="attrs" v-on="on">
                                <v-icon color="error" size="28">mdi-alert</v-icon>
                            </div>
                        </template>
                        <span>Facturas no enviadas</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div @click="showCustomerList" class="clickable-icon" v-bind="attrs" v-on="on">
                                <AppIcon src="/datos-clientes.svg" :size="28" :colorMap="{ '060647': 'primary_blue' }"/>
                            </div>
                        </template>
                        <span>Datos Clientes</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div @click="showEmisorPopup" class="clickable-icon" v-bind="attrs" v-on="on">
                                <AppIcon src="/datos-emisor.svg" :size="28" :colorMap="{ '060647': 'primary_blue' }"/>
                            </div>
                        </template>
                        <span>Datos Emisor</span>
                    </v-tooltip>

                    <slot name="search_right">
                        <div class="d-flex justify-end align-center">

                            <!-- Refrescar -->
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="refreshList()" color="primary_blue" icon v-bind="attrs" v-on="on"
                                        :loading="screen_data.loadingItems">
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </template>
                                <span>Actualizar</span>
                            </v-tooltip>

                            <!-- Añadir factura -->
                            <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn 
                                            @click="openInvoiceEditor()" 
                                            :disabled="!screen_data.hasActiveContract"
                                            color="primary_blue"
                                            icon 
                                            v-bind="attrs" 
                                            v-on="on"
                                        >
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Añadir {{screen_data.invoiceableTypeName.toLowerCase()}}</span>
                            </v-tooltip>

                            <!-- Borrar / Eliminar factura -->
                            <v-tooltip top v-if="!is_mobile">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="tryDelete()" color="primary_blue" icon v-bind="attrs" v-on="on"
                                        :disabled="!screen_data.selectedItems.length">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Eliminar {{screen_data.invoiceableTypeName.toLowerCase() + 's'}}</span>
                            </v-tooltip>

                            <JobProgress :style="is_mobile ? 'display: flex;' : ''" v-model="screen_data.asyncJobState" v-on:done="jobDone"  v-on:error="jobError" :job_id="screen_data.asyncJobId">
                                <template v-slot:progress>
                                    <v-btn
                                        color="primary_blue"
                                        v-if="screen_data.asyncJobState==='running'"
                                        icon
                                        :loading="true">
                                    </v-btn>
                                </template>
                                <template v-slot:done>
                                    <!-- Descargar factura PDF -->
                                    <v-tooltip top >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                @click="downloadPDFInvoices()"
                                                color="primary_blue"
                                                icon v-bind="attrs" v-on="on"
                                                :loading="screen_data.loadingDownload"
                                                :disabled="!screen_data.selectedItems.length">
                                                <v-icon>mdi-download</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Descargar PDF</span>
                                    </v-tooltip>
                                    <!-- Descargar factura EXCEL  -->
                                    <v-tooltip top >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                @click="downloadExcelInvoices()"
                                                color="primary_blue"
                                                icon v-bind="attrs" v-on="on"
                                                :loading="screen_data.loadingExcelDownload"
                                                :disabled="!screen_data.selectedItems.length">
                                                <v-icon>mdi-file-excel</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Descargar Excel</span>
                                    </v-tooltip>
                                    <!-- Configuración -->
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="openConfiguration()" color="primary_blue"
                                                icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-cog-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Configuración</span>
                                    </v-tooltip>
                                </template>
                                <!-- Error (TODO: Look for better way to handle this) -->
                                <template v-slot:error>
                                    <!-- Descargar factura PDF -->
                                    <v-tooltip top >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                @click="downloadPDFInvoices()"
                                                color="primary_blue"
                                                icon v-bind="attrs" v-on="on"
                                                :loading="screen_data.loadingDownload"
                                                :disabled="!screen_data.selectedItems.length">
                                                <v-icon>mdi-download</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Descargar PDF</span>
                                    </v-tooltip>
                                    <!-- Descargar factura EXCEL  -->
                                    <v-tooltip top >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                @click="downloadExcelInvoices()"
                                                color="primary_blue"
                                                icon v-bind="attrs" v-on="on"
                                                :loading="screen_data.loadingExcelDownload"
                                                :disabled="!screen_data.selectedItems.length">
                                                <v-icon>mdi-file-excel</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Descargar Excel</span>
                                    </v-tooltip>
                                    <!-- Configuración -->
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="openConfiguration()" color="primary_blue"
                                                icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-cog-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Configuración</span>
                                    </v-tooltip>
                                </template>
                            </JobProgress>

                            <!-- Desplegable (Generar remesa; Duplicar como borrador; etc.) -->
                            <v-menu
                                offset-y
                                v-model="screen_data.actionMenu"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        color="primary_blue"
                                    >
                                        <AppIcon 
                                            :src="require('@/assets/btn-show-menu.svg')" 
                                            :size="29"
                                            :colorMap="{ '060647': 'primary_blue' }"
                                        />
                                    </v-btn>

                                </template>
                                <v-list>
                                    <v-list-item
                                        link
                                        @click="$router.push({ 'name': 'product-list', 'params': { 'companydb_id': companydb_id }})"
                                    >
                                        <v-list-item-title>Productos</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('remittance') && !is_mobile"
                                        link
                                        @click="$router.push({ 'name': 'remittance-list', 'params': { 'companydb_id': companydb_id }})"
                                    >
                                        <v-list-item-title>Remesas</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('rectificative')"
                                        link
                                        @click="checkOpenRectificativeDialog()"
                                        :disabled="!screen_data.hasActiveContract"
                                    >
                                        <v-list-item-title>Crear rectificativa</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('duplicate')"
                                        link
                                        @click="duplicateAsDraft()"
                                        :disabled="!screen_data.hasActiveContract"
                                    >
                                        <v-list-item-title>Duplicar como borrador</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('send_to_accounting')"
                                        link
                                        @click="sendToAccounting()"
                                    >
                                        <v-list-item-title>Enviar al módulo de contabilidad</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('generate_invoice')"
                                        link
                                        @click="generateInvoiceFromInvoiceable()"
                                        :disabled="!screen_data.hasActiveContract"
                                    >
                                        <v-list-item-title>Generar factura</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('remittance') && !is_mobile"
                                        link
                                        @click="showRemittancePopUp()"
                                        :disabled="!screen_data.hasActiveContract"
                                    >
                                        <v-list-item-title>Generar remesa</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        link
                                        @click="massiveSendViaEmail()"
                                    >
                                        <v-list-item-title>Enviar por correo</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('recurring_invoice')"
                                        link
                                        @click="goRecurringInvoice()"
                                    >
                                        <v-list-item-title>Factura recurrente</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('can_sign')"
                                        link
                                        @click="massiveSign()"
                                        :disabled="!screen_data.hasActiveContract"
                                    >
                                        <v-list-item-title>Firmar y emitir</v-list-item-title>
                                    </v-list-item>
                                    <!-- Método de pago masivo -->
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('massive_payment_means')"
                                        link
                                        @click="showPaymentMeans()"
                                        :disabled="!screen_data.hasActiveContract"
                                    >
                                        <v-list-item-title>Añadir método de pago masivamente</v-list-item-title>
                                    </v-list-item>
                                    <!-- Fecha vencimiento masivo -->
                                    <v-list-item
                                        v-if="screen_data.availableActions.includes('massive_due_date')"
                                        link
                                        @click="showDueDate()"
                                        :disabled="!screen_data.hasActiveContract"
                                    >
                                        <v-list-item-title>Añadir fecha de vencimiento masivamente</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        link
                                        @click="$router.push({ 'name': 'invoice-history-list', 'params': { 'companydb_id': companydb_id }})"
                                    >
                                        <v-list-item-title>Registro de facturas</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="im_staff_or_loginas" 
                                        link
                                        @click="massiveSignToDraft()"
                                    >
                                        <v-list-item-title>Pasar las facturas a borrador</v-list-item-title>
                                    </v-list-item>                                    
                                </v-list>
                            </v-menu>

                        </div>
                    </slot>
                </div>
            </v-card-title>

            <v-card-text class="px-0 pt-0 card-title-footer-color">
                <v-divider v-if="is_mobile"/>
                <!-- Fila Añadir filtro Borrar filtros -->
                <v-row :class="{'ma-1': is_mobile, 'pa-0': is_mobile,'justify-center': is_mobile, 'ma-0': !is_mobile}">
                    <app-search-bar
                        v-if="!is_mobile"
                        :filters="screen_data.availableFilters"
                        @updateObject="updateFilter"
                        @resetAllFilters="removeAllFilt"
                    />
                    <app-filters-mobile
                        v-else
                        class="mx-0 pa-0"
                        :filters="Object.fromEntries(Object.entries(screen_data.availableFilters).filter(([key]) => key !== 'kind'))"
                        :is_open="true"
                        @click.native="hideCrisp"
                        @updateObject="updateFilter"
                        @resetAllFilters="removeAllFilt"
                    />
                </v-row>
                <v-row v-if="is_mobile" :style="{ backgroundColor: 'color-mix(in srgb, var(--v-primaryLight-base) 20%, white)' }" class="mx-0">
                    <v-col cols="4" class="pa-0 d-flex justify-center">
                        <v-btn
                            text
                            color="primary"
                            @click="toggleFilter('recived')"
                        >
                            <span
                                :class="{
                                    'v-btn--active': filter_mobile_type === 'recived',
                                    'px-0': true,
                                    'item-filter': true
                                }"
                            >
                                <span class="px-1 d-flex align-center justify-content-center">
                                    <AppIcon :src="require(`@/assets/einvoice-received-filter.svg`)" :size="29" />
                                Recibidas
                                </span>
                            </span>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="pa-0 d-flex justify-center">
                        <v-btn
                            text
                            color="primary"
                            @click="toggleFilter('signed')"
                        >
                            <span
                                class=""
                                :class="{
                                    'v-btn--active': filter_mobile_type === 'signed',
                                    'px-0': true,
                                    'item-filter': true
                                }"
                            >
                                <span class="px-1 d-flex align-center justify-content-center">
                                    <AppIcon :src="require(`@/assets/einvoice-issued-filter.svg`)" :size="29" />
                                    Emitidas
                                </span>
                            </span>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="pa-0 d-flex justify-center">
                        <v-btn
                            text
                            color="primary"
                            @click="toggleFilter('draft')"
                        >
                            <span
                                :class="{
                                    'v-btn--active': filter_mobile_type === 'draft',
                                    'px-0': true,
                                    'item-filter': true
                                }"
                            >
                                <span class="px-1 d-flex align-center justify-content-center">
                                    <AppIcon :src="require(`@/assets/einvoice-draft-filter.svg`)" :size="29" />
                                    Borrador
                                </span>
                            </span>
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- Tabla de listado de facturas móvil  -->
                <v-container
                    v-if="is_mobile"
                    v-model="screen_data.selectedItems"
                    :show-select="screen_data.showSelect"
                    :loading="screen_data.loadingItems"
                    :server-items-length="screen_data.totalItems"
                    :no-data-text="screen_data.textNoResults"
                    :loading-text="screen_data.textLoading"
                    @update:sort-by="sortTable"
                    @update:sort-desc="sortTableDesc"
                    @update:items-per-page="changeLimit"
                    @update:page="changeOffset"
                    :item-key="screen_data.itemKey"
                >
                    <v-row
                        v-for="(item, rowIndex) in screen_data.invoices"
                        :key="rowIndex"
                        class="mb-4 pb-2 mobile-table-row"
                    >

                        <!-- Contenedor Principal Listado de Facturas -->
                        <v-col class="px-3 px-6 py-0">

                            <!-- Card Listado de Facturas -->
                            <v-row
                                class="d-flex align-center py-1"
                                @click="selectRow(item)"
                                style="border-bottom: 1px solid #dcdcdc; row-gap: 0;"
                                >
                                <!-- Nombre / Empresa -->
                                <v-col cols="12" class="py-0">
                                <span v-if="item['customer'].type === 'fisica'" style="font-size: 22px; font-weight: 700; line-height: 1.1;">
                                    {{ item['customer'].first_surname }} {{ item['customer'].second_surname }}, {{ item['customer'].name }}
                                </span>
                                <span v-else style="font-size: 22px; font-weight: 700; line-height: 1.1;">
                                    {{ item['customer'].business_name }}
                                </span>
                                </v-col>

                                <!-- CIF y Estado -->
                                <v-col cols="6" class="py-0">
                                <span style="font-size: 15px; font-weight: 500; color: #444;">
                                    {{ item['customer'].cif }}
                                </span>
                                </v-col>

                                <v-col cols="6" class="py-0 d-flex justify-end align-center">
                                <span
                                    style="font-size: 14px; font-weight: 500; color: #2e7d32; background-color: #e8f5e9; padding: 2px 10px; border-radius: 12px;"
                                >
                                    {{ stateToShow(item['state']) }}
                                </span>
                                </v-col>

                                <!-- Número de Factura y Fecha -->
                                <v-col cols="6" class="py-0">
                                <span style="font-size: 14px; color: #666;">
                                    {{ item.invoice_number }}
                                </span>
                                </v-col>

                                <v-col cols="6" class="py-0 d-flex justify-end">
                                <span style="font-size: 14px; color: #666;">
                                    {{ formatDate(item.invoice_date) }}
                                </span>
                                </v-col>

                                <!-- Botones -->
                                <v-col cols="7" class="pt-1 pb-0 d-flex align-center">
                                    <v-btn
                                        icon
                                        @click.stop="showInfo(item)"
                                        :class="{'v-btn--active': isActiveInfo === item.id}"
                                        style="padding: 4px; height: 36px; width: 36px;"
                                    >
                                        <AppIcon :src="require(`@/assets/einvoice-info-${isActiveInfo === item.id ? 'black' : 'white'}.svg`)" :size="29" style="height: 34px;" />
                                    </v-btn>

                                    <v-btn
                                        icon
                                        data-test="iconDownloadPDFInvoices"
                                        @click.stop
                                        @click="downloadPDFInvoices(item)"
                                        :class="{'v-btn--active': isActiveDownload === item.id}"
                                        style="padding: 4px; height: 36px; width: 36px;"
                                    >
                                        <AppIcon :src="require(`@/assets/einvoice-download-${isActiveDownload === item.id ? 'black' : 'white'}.svg`)" :size="29" style="height: 34px;" />
                                    </v-btn>
                                </v-col>

                                <!-- Total -->
                                <v-col cols="5" class="pt-1 pb-0 d-flex justify-end">
                                <span style="font-size: 19px; font-weight: 700;">
                                    {{ (Math.round(item.total_amount * 100) / 100).toFixed(2) }} €
                                </span>
                                </v-col>
                            </v-row>

                            <!-- Icono Campo Info -->
                            <template v-if="isActiveInfo === item.id">
                                <v-card
                                    class="pa-4 rounded-xl elevation-1"
                                    style="
                                    background-color: rgb(250, 249, 254);
                                    border-left: 4px solid rgb(156, 77, 204);
                                    margin: 10px 0px 4px;
                                    "
                                >
                                    <div class="d-flex align-center justify-space-between mb-4">
                                    <span style="font-size: 14px; font-weight: 600; color: #5e3fa1;">
                                        {{ paymentStateToShow(item['payment_state']) }}
                                    </span>
                                    </div>

                                    <v-row no-gutters class="text-body-2" style="row-gap: 6px;">
                                    <v-col cols="12" class="d-flex justify-space-between">
                                        <span class="grey--text text--darken-1">ID</span>
                                        <span>{{ item.id }}</span>
                                    </v-col>

                                    <v-col cols="12" class="d-flex justify-space-between">
                                        <span class="grey--text text--darken-1">No. Fact. Extern</span>
                                        <span>{{ item.external_invoice_number || '-' }}</span>
                                    </v-col>

                                    <v-col cols="12" class="d-flex justify-space-between">
                                        <span class="grey--text text--darken-1">F. Vec</span>
                                        <span>{{ item.invoice_due_date }}</span>
                                    </v-col>
                                    </v-row>
                                </v-card>
                            </template>

                        </v-col>

                    </v-row>
                </v-container>

                <!-- Tabla de listado de facturas no móvil  -->
                <div v-else>
                    <v-data-table
                        v-model="screen_data.selectedItems"
                        :items="screen_data.invoices"
                        :footer-items-per-page-text="screen_data.footerItemsPerPageText"
                        :footer-items-per-page-options="screen_data.footerItemsPerPageOptions"
                        :headers="filteredHeaders"
                        :show-select="screen_data.showSelect"
                        :loading="screen_data.loadingItems"
                        :server-items-length="screen_data.totalItems"
                        :footer-props="{
                            'items-per-page-text': screen_data.footerItemsPerPageText,
                            'items-per-page-options': screen_data.footerItemsPerPageOptions,
                        }"
                        :no-data-text="screen_data.textNoResults"
                        :loading-text="screen_data.textLoading"
                        @toggle-select-all=""
                        @update:sort-by="sortTable"
                        @update:sort-desc="sortTableDesc"
                        @update:items-per-page="changeLimit"
                        @update:page="changeOffset"
                        :item-key="screen_data.itemKey"
                        @click:row="selectRow"
                    >
                        <!-- Columnas Personalizables -->
                        <template
                            v-for="header in filteredHeaders"
                            v-slot:[`item.${header.value}`]="{ item }"
                        >

                            <span :key="header.value" class="font-color">
                                <slot v-if="header.value == 'state' " v-bind="item">
                                    {{stateToShow(item['state'])}}
                                </slot>
                                <slot v-else-if="header.value == 'payment_means' " v-bind="item">
                                    {{paymentMeansToShow(item['payment_means'])}}
                                </slot>
                                <slot v-else-if="header.value == 'payment_state' " v-bind="item">
                                    {{paymentStateToShow(item['payment_state'])}}
                                </slot>
                                <slot v-else-if="header.value == 'customer_name'" :name="header.value" v-bind="item">
                                    <span v-if="item['customer'].type == 'fisica'">{{item['customer'].first_surname}} {{item['customer'].second_surname}}, {{item['customer'].name}}</span>
                                    <span v-else>{{ item['customer'].business_name }}</span>
                                </slot>
                                <slot v-else-if="header.value == 'customer_cif'" :name="header.value" v-bind="item">
                                    {{ item['customer'].cif }}
                                </slot>
                                <slot v-else-if="header.value == 'kind'" :name="header.value" v-bind="item">
                                    {{ kindToShow(item['kind']) }}
                                </slot>
                                <slot v-else-if="header.value == 'total_amount'" :name="header.value" v-bind="item">
                                    <div class="text-right">
                                        {{ (Math.round(item[header.value]*100 ) /100) }} €
                                    </div>
                                </slot>
                                <slot v-else-if="header.value == 'accounting_document_id'" :name="header.value" v-bind="item">
                                    <span v-if="item['accounting_document_id']"
                                        @click.stop="goToAccountingDocument(item['accounting_document_id'])"
                                        @mousedown="goToAccountingDocumentNewTab(item['accounting_document_id'], $event)"
                                        class="primary--text accounting-link" >
                                        {{ item['accounting_document_id'] }}
                                    </span>
                                </slot>
                                <slot v-else-if="['invoice_due_date', 'invoice_date'].includes(header.value)" :name="header.value" v-bind="item">
                                    {{ formatDate(item[header.value]) }}
                                </slot>
                                <slot v-else-if="header.value == 'id'" :name="header.value" v-bind="item">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div
                                                class="tooltip-container"
                                                @contextmenu.prevent="copyToClipboard(item[header.value])"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                            {{ item[header.value] }}
                                            </div>
                                        </template>
                                        <span>Click derecho para copiar ID</span>
                                    </v-tooltip>
                                </slot>
                                <slot v-else :name="header.value" v-bind="item">{{item[header.value] }}</slot>
                            </span>
                        </template>
                        <template v-if="screen_data.hideHeaderCheckbox" #header.data-table-select></template>
                        <!-- Header Personalizables -->
                        <template
                            v-for="header in filteredHeaders"
                            v-slot:[`header.${header.value}`]="{ header }"
                        >
                            <v-checkbox
                                v-if="header.checkbox"
                                :key="header.value + '-hdr-checkbox'"
                                class="ma-0 pa-0"
                                @change="changeColSelected(header)"
                                :value="header.selected"
                                hide-details
                            >
                                <template v-slot:label>
                                    <span>{{ header.text }}</span>
                                </template>
                            </v-checkbox>
                            <span v-else :key="header.value + '-hdr-span'" tabindex="0">
                                {{ header.text }}
                            </span>
                        </template>
                        <!--Footer: Paginación-->
                        <template v-slot:[`footer.page-text`]="items">
                            {{ items.pageStart }} - {{ items.pageStop }} de
                            {{ items.itemsLength }}
                        </template>
                    </v-data-table>
                </div>
            </v-card-text>

        </v-card>

        <!-- Pending Email Invoices Dialog -->
        <v-dialog v-model="showPendingEmailDialog" max-width="400" persistent>
            <v-card>
                <v-card-title class="error white--text">
                    Error en el envío de facturas
                </v-card-title>
                <v-card-text class="px-8 py-5">
                    <p class="text-subtitle-1 mb-4 text-left pl-2">
                        <span >
                            <strong>{{ pendingEmailInvoices.length }}</strong> factura{{ pendingEmailInvoices.length === 1 ? '' : 's' }} no se {{ pendingEmailInvoices.length === 1 ? 'ha' : 'han' }} podido enviar por email:
                        </span>
                    </p>
                    <v-list dense max-height="400" class="overflow-y-auto pending-email-list">
                        <v-list-item
                            v-for="invoice in pendingEmailInvoices"
                            :key="invoice.id"
                            class="px-0 mb-2"
                        >
                            <v-list-item-content>
                                <v-list-item-title class="error--text pl-2 font-weight-bold">
                                    · Número de factura: {{ invoice.invoice_number }}
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="invoice.pending_email_error" class="pl-4 pt-1 text-wrap">
                                    <span class="grey--text text--darken-2">
                                        <v-icon small class="mr-1">mdi-alert-circle-outline</v-icon>
                                        {{ invoice.pending_email_error }}
                                    </span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions class="pb-5 justify-center">
                    <v-btn
                        outlined
                        @click="showPendingEmailDialog = false"
                        class="action__btn mx-2"
                    >
                        Cerrar
                    </v-btn>
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn mx-2"
                        @click="retryPendingEmails"
                        :loading="retryingEmails"
                    >
                        Reintentar Envíos
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Popup Recordatorio Series 2026 -->
        <v-dialog v-model="showSequence2026Popup" max-width="550" persistent>
            <v-card>
                <v-card-title class="d-flex align-center primary_blue white--text">
                    <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
                    <span class="font-weight-bold">Recordatorio Importante</span>
                </v-card-title>
                <v-card-text class="pa-6">
                    <p class="text-body-1 mb-4">
                        <strong>Recuerda crear las series de facturación para el año 2026.</strong>
                    </p>
                    <p class="text-body-2 grey--text text--darken-1">
                        Para evitar errores, asegúrate de crear nuevas series con el prefijo o numeración correspondiente al año 2026 antes de emitir facturas.
                    </p>
                    <p class="text-body-2 grey--text text--darken-1 mt-3">
                        Puedes gestionar las series desde el botón de <strong>Configuración</strong>
                        <v-icon small color="primary_blue">mdi-cog-outline</v-icon>
                        en la barra de herramientas.
                    </p>
                </v-card-text>
                <v-card-actions class="pb-5 justify-center">
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="dismissSequence2026Popup"
                        :loading="dismissingPopup"
                    >
                        Entendido
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { ApiInvoiceableRepository } from "@/modules/facturae/infra/ApiInvoiceableRepository";
import {VueInvoiceListScreenData, VueBudgetListScreenData, VueDeliveryNoteListScreenData, VueProformaListScreenData, VueTicketListScreenData} from '@/modules/facturae/infra/VueInvoiceListScreenData'
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue' 
import SequenceConfig from '@/components/SequenceConfig.vue'
import { mapGetters, mapState } from "vuex";
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import AppTextField from "@/components/layout/AppTextField.vue";
import AppDateField from "@/modules/widgets/infra/AppDateField.vue";
import { STATE_TRANSLATOR, PAYMENT_STATE_TRANSLATOR, PAYMENT_MEANS_OPTIONS, PAYMENT_MEANS_CODE_TEXT} from '@/modules/facturae/domain/Invoiceable'
import { InvoiceListComponent } from "@/modules/facturae/app/InvoiceListComponent";
import { S3Repository } from "@/modules/shared/infra/S3Repository";
import awsconfig from '@/aws-exports';
import EInvoiceConfig from "@/components/EInvoiceConfig.vue";
import JobProgress from '@/components/JobProgress.vue';
import { jobs } from '@/api/jobs.js';
import AppSearchBar from '@/components/layout/AppSearchBar.vue';
import AppFiltersMobile from '@/components/layout/AppFiltersMobile.vue';
import { ApiConfigurationRepository } from "./ApiConfigurationRepository";
import { VueFeatureRepository } from '@/modules/shared/infra/FeatureRepository';
import AccessDeniedToFacturaEPopup from "@/components/AccessDeniedToFacturaEPopup.vue";
import { trueDependencies } from "mathjs";
import PopUpEmisor from "@/components/PopUpEmisor.vue";

export default {
    name: "InvoiceablesListComponent",
    components: {
        AppTextField,
        AppBtn,
        AppCol,
        AppRow,
        AppConfirmModal,
        AppDateField,
        SequenceConfig,
        EInvoiceConfig,
        JobProgress,
        AppSearchBar,
        AppFiltersMobile,
        AccessDeniedToFacturaEPopup,
        PopUpEmisor
    },
    data() {
        const screen_data = this.invoiceable_type === 'budget' ? new VueBudgetListScreenData() :
                    this.invoiceable_type === 'delivery_note' ? new VueDeliveryNoteListScreenData() :
                    this.invoiceable_type === 'proforma' ? new VueProformaListScreenData() :
                    this.invoiceable_type === 'ticket' ? new VueTicketListScreenData() :
                    new VueInvoiceListScreenData();
        return {
            conf_pop_up: false,
            delete_pop_up: false,
            sign_to_draft_popup: false,
            delete_invoice_number: false,
            state_translator : STATE_TRANSLATOR,
            payment_state_translator : PAYMENT_STATE_TRANSLATOR,
            screen_data:screen_data,
            invoice_list_component:null,
            creds: undefined,
            dateVisible: false,
            isActiveInfo: false,
            isActiveDownload: false,
            filter_mobile_type: "",
            configurationReady: false,
            retryingEmails: false,
            showPendingEmailDialog: false,
            pendingEmailInvoices: [],
            showSequence2026Popup: false,
            dismissingPopup: false,
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
        invoiceable_type: {
            type: String,
            required: false,
            default: 'invoice'
        },
    },
    watch: {
        companydb_id: async function() {
            // Marcar como no lista mientras se recarga la configuración
            this.configurationReady = false;
            this.screen_data.companydbLoaded = false;
            await this.invoice_list_component.mountList(this.companydb_id)
            await this.invoice_list_component.fetchConfiguration(this.companydb_id)
            await this.invoice_list_component.companyHasActiveEinvoiceContract(Number(this.companydb_id))
            this.screen_data.companydb_id = this.companydb_id
            this.invoice_list_component.setCurrentCompanyDB(this.currentCompany)
            // Marcar como lista después de recargar
            this.configurationReady = true;
            // Verificar si mostrar popup de recordatorio de series 2026 para la nueva empresa
            this.checkAndShowSequence2026Popup();
        }
    },
    async mounted() {
        this.creds = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
        });
        this.creds.params.Logins = this.creds.params.Logins || {};
        this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] =  this.session_information.signInUserSession.idToken.jwtToken;
        this.creds.expired = true;
        AWS.config.update({
            region: awsconfig['aws_user_files_s3_bucket_region'],
            credentials: this.creds,
        });
        let file_repo = new S3Repository(AWS, 'einvoice');
        let invoice_repo = new ApiInvoiceableRepository();
        let config_repo = new ApiConfigurationRepository()
        let feature_repo= new VueFeatureRepository(this.got_feature)
        this.invoice_list_component = new InvoiceListComponent(invoice_repo, this.screen_data, config_repo, file_repo, this.invoiceable_type, feature_repo);
        await this.invoice_list_component.companyHasActiveEinvoiceContract(Number(this.companydb_id))
        this.refreshList();
        await this.loadPendingEmailInvoices();
        await this.invoice_list_component.fetchConfiguration(this.companydb_id)
        const taxType = this.screen_data.configuration.tax_type || 'iva';
        this.screen_data.new_invoice = invoice_repo.create_empty_invoiceable(this.companydb_id, this.currentCompany, this.screen_data.configuration.sequences[0].next_number, this.screen_data.configuration.sequences[0].next_rectificative_number, taxType, this.invoiceable_type)
        this.screen_data.paymentMeansOptions = PAYMENT_MEANS_OPTIONS;
        this.screen_data.companydb_id = this.companydb_id
        this.invoice_list_component.setCurrentCompanyDB(this.currentCompany)
        // Marcar que la configuración ya está lista
        this.configurationReady = true;
        // Verificar si mostrar popup de recordatorio de series 2026
        this.checkAndShowSequence2026Popup();
    },
    methods: {
        closePopup() {
            this.screen_data.showPopUp = false;
            this.screen_data.messagePopUp = '';
        },
        closePopupSuccessful() {
            this.screen_data.showPopUpSuccessful = false;
            this.screen_data.messagePopUpSuccessful = '';
        },
        closePopUpPaymentMeans() {
            this.screen_data.showPopUpPaymentMeans = false;
        },
        closePopupDueDate(){
            this.screen_data.showPopUpDueDate = false;
        },
        closePopUpPaymentMeansDueDate(){
            this.screen_data.showPopUpPaymentMeansDueDate = false;
        },
        closeShowGenerateRemittancePopup() {
            this.screen_data.showGenerateRemittancePopUp = false;
            this.screen_data.messageShowGenerateRemittancePopUp = '';
        },
        closeShowRemittancePaymentNo02Alert() {
            this.screen_data.showRemittancePaymentNo02Alert = false;
            this.screen_data.showRemittanceTypePopUp = true;
        },
        openConfiguration() {
            if (!this.configurationReady) {
                // Mostrar un mensaje al usuario indicando que debe esperar
                this.screen_data.snackbar.text = 'Cargando configuración, por favor espera un momento...';
                this.screen_data.snackbar.color = 'info';
                this.screen_data.snackbar.isVisible = true;
                return;
            }
            this.conf_pop_up = true;
        },
        async updateFilter(params){
            this.invoice_list_component.updateFilters(params)
            await this.invoice_list_component.mountList(this.companydb_id)
        },
        async removeAllFilt(p){
            this.invoice_list_component.celanAllFilters()
            await this.invoice_list_component.mountList(this.companydb_id)
        },
        async refreshList(){
            await this.invoice_list_component.mountList(this.companydb_id)
            await this.loadPendingEmailInvoices()
        },
        async loadPendingEmailInvoices() {
            try {
                const invoice_repo = new ApiInvoiceableRepository();
                this.pendingEmailInvoices = await invoice_repo.get_pending_email_invoices(
                    Number(this.companydb_id),
                    this.invoiceable_type
                );
            } catch (error) {
                console.error('Error loading pending email invoices:', error);
                this.pendingEmailInvoices = [];
            }
        },
        selectRow(item) {
            if (this.invoiceable_type == 'budget') {
                this.$router.push({ 'name': "budget-editor", 'params': { 'companydb_id': this.companydb_id, 'budget_id': item.id, 'invoiceable_id_list': this.screen_data.invoiceableIdList }})
                return
            } else if (this.invoiceable_type === 'delivery_note') {
                this.$router.push({ 'name': 'delivery-note-editor', 'params': { 'companydb_id': this.companydb_id, 'delivery_note_id': item.id, 'invoiceable_id_list': this.screen_data.invoiceableIdList }})
                return
            } else if (this.invoiceable_type == 'proforma') {
                this.$router.push({ 'name': "proforma-editor", 'params': { 'companydb_id': this.companydb_id, 'proforma_id': item.id, 'invoiceable_id_list': this.screen_data.invoiceableIdList }})
                return
            } else if (this.invoiceable_type == 'ticket') {
                this.$router.push({ 'name': "ticket-editor", 'params': { 'companydb_id': this.companydb_id, 'ticket_id': item.id, 'invoiceable_id_list': this.screen_data.invoiceableIdList }})
                return
            }
            this.$router.push({ 'name': "invoice-editor", 'params': { 'companydb_id': this.companydb_id, 'invoice_id': item.id, 'invoiceable_id_list': this.screen_data.invoiceableIdList }})
        },
        openInvoiceEditor() {
            let default_sequence = null
            if (this.screen_data.configuration.sequences.length > 0) {
                let not_recurring_sequences = this.screen_data.configuration.sequences.filter(seq => !seq.is_for_recurring_contracts && !seq.disabled)
                if (not_recurring_sequences.length > 0) {
                    default_sequence = not_recurring_sequences[0]
                } else {
                    if (this.screen_data.configuration.sequences[0] && !this.screen_data.configuration.sequences[0].disabled) {
                        default_sequence = this.screen_data.configuration.sequences[0]
                    }
                }
            }
            let next_number = default_sequence ? default_sequence.next_number : null
            let next_rectificative_number = default_sequence ? default_sequence.next_rectificative_number : null
            let default_sequence_id = default_sequence ? default_sequence.id : null

            if (this.invoiceable_type == 'budget') {
                this.$router.push({ 'name': 'budget-editor', 'params': { 'companydb_id': this.companydb_id ,'next_number': next_number, 'default_sequence_id': default_sequence_id }})
                return
            } else if (this.invoiceable_type === 'delivery_note') {
                this.$router.push({ 'name': 'delivery-note-editor', 'params': { 'companydb_id': this.companydb_id ,'next_number': next_number, 'default_sequence_id': default_sequence_id }})
                return
            } else if (this.invoiceable_type == 'proforma') {
                this.$router.push({ 'name': 'proforma-editor', 'params': { 'companydb_id': this.companydb_id ,'next_number': next_number, 'default_sequence_id': default_sequence_id }})
                return
            } else if (this.invoiceable_type == 'ticket') {
                this.$router.push({ 'name': 'ticket-editor', 'params': { 'companydb_id': this.companydb_id ,'next_number': next_number, 'default_sequence_id': default_sequence_id }})
                return
            }
            this.$router.push({ 'name': 'invoice-editor', 'params': { 'companydb_id': this.companydb_id ,'next_number': next_number, 'next_rectificative_number': next_rectificative_number, 'default_sequence_id': default_sequence_id }})
        },
        redirectToList(option) {
            if (this.$router.currentRoute.name != option) {
                this.$router.push({'name': option,'params': { 'companydb_id': this.companydb_id }})
            }
        },
        saveConfig(data) {
            this.conf_pop_up = false
            this.screen_data.dirtyUploadedLogo = data.dirty
            this.screen_data.file = data.file
            this.invoice_list_component.saveConfiguration()
        },
        calcelSaveConfig() {
            this.conf_pop_up = false
            this.invoice_list_component.fetchConfiguration(this.companydb_id)
        },
        stateToShow(state){
            if (this.state_translator[state]){
                return this.state_translator[state]
            }
            return state
        },
        paymentStateToShow(state){
            if (this.payment_state_translator[state]){
                return this.payment_state_translator[state]
            }
            return state
        },
        kindToShow(kind){
            if (kind == 'in_invoice'){
                return this.invoiceable_type == 'invoice' ? 'Recibida' : 'Recibido'
            }
            return this.invoiceable_type == 'invoice' ? 'Emitida' : 'Emitido'
        },
        sortTable(value){
            if (value.length){
                this.screen_data.sort_by = value[0]
                this.invoice_list_component.mountList(this.companydb_id)
            }
            else{
                this.screen_data.sort_by = ''
                this.invoice_list_component.mountList(this.companydb_id)
            }

            //this.invoice_list_component.sortTable(value)
        },
        sortTableDesc(value){
            if (value.length && value[0]){
                this.screen_data.sort_by = '-'+this.screen_data.sort_by
                this.invoice_list_component.mountList(this.companydb_id)
            }
            //this.invoice_list_component.sortTableDesc(value)
        },
        filterItems(){
            this.invoice_list_component.mountList(this.companydb_id)
        },
        changeLimit(value){
            this.screen_data.limit = value
            this.invoice_list_component.mountList(this.companydb_id)
        },
        changeOffset(value){
            this.screen_data.offset = (value-1)*this.screen_data.limit
            this.invoice_list_component.mountList(this.companydb_id)
        },
        async downloadPDFInvoices(invoice){
            if (this.is_mobile){
                this.screen_data.selectedItems = invoice ? [invoice] : this.screen_data.selectedItems
            }
            await this.invoice_list_component.download_pdf_invoices()
        },
        async downloadExcelInvoices() {
            console.log("Click Download Excel")
            await this.invoice_list_component.downloadExcelInvoices()
        },
        tryDelete(){
            let allow = true;
            for(let i = 0; i < this.screen_data.selectedItems.length; i++){
                if (this.screen_data.selectedItems[i].state != 'draft'){
                    allow = false;
                    break;
                }
            }
            if (allow){
                this.delete_pop_up = true;
            }
            else{
                const doc_type = this.invoiceable_type === 'delivery_note' ? 'albaranes' : 
                           this.invoiceable_type === 'budget' ? 'presupuestos' : 
                           this.invoiceable_type === 'proforma' ? 'proformas' :
                           this.invoiceable_type === 'ticket' ? 'facturas simplificadas' : 'facturas'
                this.screen_data.error_message(`No se pueden eliminar ${doc_type} que no estén en estado borrador`)
            }

        },
        async deleteSelectedItems(){
            this.delete_pop_up = false;
            await this.invoice_list_component.deleteSelectedItems()
            await this.refreshList() //por no tener que pasar el companydb_id al delete
        },
        formatDate(date) {
            let d = new Date(date);
            if (isNaN(d)) {
                return date;
            } else if (!date) {
                return '';
            }
            let day = String(d.getDate()).padStart(2, '0');
            let month = String(d.getMonth() + 1).padStart(2, '0');
            let year = d.getFullYear();
            return `${day}/${month}/${year}`;
        },
        async jobError(){
            const response = await jobs.getJob({ id: this.screen_data.asyncJobId });
            console.log(response.data)
            if(response.data.params && response.data.params.command && response.data.params.command.cmd_name == "massive.run.command"){
                if (response.data.params.command.cmd_to_run_name == "sign.static.invoice.xml"){
                    this.screen_data.showPopUp = true;
                    this.screen_data.messagePopUp="Se ha interrumpido el proceso. No se han podido firmar y emitir todas las facturas seleccionadas.";
                }
                else if (response.data.params.command.cmd_to_run_name == "add.due.date"){
                    this.screen_data.showPopUp = true;
                    this.screen_data.messagePopUp="Se ha interrumpido el proceso. No se ha podido añadir añadir la fecha de vencimiento.";
                }
            }
            await this.refreshList();

        },
        async jobDone() {
            const response = await jobs.getJob({ id: this.screen_data.asyncJobId });
            this.screen_data.asyncJobState = response.data.state;
            if (this.screen_data.asyncJobState == 'done'){
                await this.refreshList();
                if (Object.keys(response.data.output_info).includes('url') ){
                    await this.invoice_list_component.downloadZipFile(response.data.output_info['url'])
                    this.screen_data.selectedItems = []
                }
                else if (response.data.output_info['status'] == 'ok') {
                    this.screen_data.configuration.company_id = response.data.output_info['company_id']
                    // Revisar esto por tema del orden de asignacion
                    // for (let x in this.screen_data.company.sequences) {
                    //     if (this.screen_data.company.sequences[x] && response.data.output_info['sequences_ids'][x]) {
                    //         this.screen_data.company.sequences[x].id = response.data.output_info['sequences_ids'][x]
                    //     }
                    // }
                    //this.screen_data.company.sequence.id = response.data.output_info['sequence_id']
                    this.invoice_list_component.fetchConfiguration(this.companydb_id)
                    this.screen_data.success_message('Configuración guardada')

                }
                else if(response.data.output_info && response.data.output_info.success===true) {
                    this.screen_data.success_message(response.data.output_info["message"])
                }
                else if(response.data.output_info && response.data.output_info.success===false){
                    this.screen_data.showPopUp = true;
                    this.screen_data.messagePopUp=response.data.output_info["message"];
                }
                else if(response.data.params && response.data.params.command && response.data.params.command.cmd_name == "massive.run.command"){
                    if (response.data.params.command.cmd_to_run_name == "sign.static.invoice.xml"){
                        this.screen_data.showPopUpSuccessful = true;
                        this.screen_data.messagePopUpSuccessful="La firma y emisión de las facturas ha sido realizada correctamente.";
                        // GESTIÓN DE MENSAJES DE ERROR:
                        // if (!verifactu_error){ 
                        //     this.screen_data.showPopUpSuccessful = true;    
                        //     this.screen_data.messagePopUpSuccessful="La firma y emisión de las facturas ha sido realizada correctamente.";
                        // }    
                        // else {
                        //     this.screen_data.showPopUpSuccessful = true; 
                        //     this.screen_data.messagePopUpVerifactuWarning = "El paquete de facturas seleccionado contiene registros con errores."
                        // }
                    }
                    else if (response.data.params.command.cmd_to_run_name == "add.due.date"){
                        this.screen_data.showPopUpSuccessful = true;
                        this.screen_data.messagePopUpSuccessful="La fecha de vencimiento se ha añadido correctamente.";
                    }
                    else if (response.data.params.command.cmd_to_run_name == "add.payment.means"){
                        this.screen_data.showPopUpSuccessful = true;
                        this.screen_data.messagePopUpSuccessful="El método de pago se ha añadido correctamente.";
                    }
                }
                else if(response.data.output_info && response.data.output_info.results){
                    this.screen_data.success_message('Operación realizada correctamente')
                }
                else {
                    this.screen_data.error_message('Error')
                }
            } else {
                this.screen_data.error_message('Error')
            }
        },
        checkOpenRectificativeDialog() {
            if (this.screen_data.selectedItems.length > 1) {
                this.screen_data.error_message('Solo está permitido crear una factura rectificativa a la vez')
                return
            } else if (this.screen_data.selectedItems.length == 1) {
                if (this.screen_data.selectedItems[0].state == 'draft') {
                    this.screen_data.error_message('Solo se pueden crear facturas rectificativas de facturas emitidas')
                    return
                } else if (this.screen_data.selectedItems[0].rectificative) {
                    this.screen_data.error_message('No se pueden crear facturas rectificativas de facturas rectificativas')
                    return
                }
            }
            this.screen_data.createRectificativeDialog = true
        },
        goToAccountingDocument(accountingId){
            this.$router.push({ name: 'document-detail', params: {'companydb_id':this.companydb_id, 'document':accountingId} });
        },
        goToAccountingDocumentNewTab(accountingId, event) {
            if (event.button === 1 || event.button === 2) { // Detecta clic con la rueda del ratón
                event.preventDefault(); // Evita cualquier comportamiento inesperado
                const routeData = this.$router.resolve({
                    name: 'document-detail',
                    params: { companydb_id: this.companydb_id, document: accountingId }
                });
                window.open(routeData.href, '_blank');
            }
        },
        async tryCreate() {
            this.screen_data.new_invoice.rectificative = true
            let res = await this.invoice_list_component.createRectificative()
            if (res) {
                this.screen_data.createRectificativeDialog = false
                this.screen_data.setLoading(false)
                this.$router.push({ 'name': "invoice-editor", 'params': { 'companydb_id': this.companydb_id, 'invoice_id': res }})
                return
            } else {
                this.screen_data.setLoading(false)
                this.screen_data.error_message('Error al crear factura rectificativa')
                return
            }
        },

        async duplicateAsDraft(){
            let res = await this.invoice_list_component.duplicateAsDraft()
            if (res) {
                await this.refreshList()
            }
        },

        async sendToAccounting(){
            let res = await this.invoice_list_component.sendToAccounting()
            if (res["success"]===false) {
                this.screen_data.showPopUp = true;
                this.screen_data.messagePopUp=res["message"];
            }
        },

        check_can_generate_invoices() {
            let some_invalid = this.screen_data.selectedItems.some(item =>
                (item['type'] === 'budget' && item['state'] !== 'accepted') ||
                (item['type'] === 'delivery_note' && !['issued', 'b_sent'].includes(item['state'])) ||
                (item['type'] === 'proforma' && item['state'] ==='invoiced')
            );
            if (some_invalid) {
                if (this.invoiceable_type == 'delivery_note') {
                    this.screen_data.error_message('No se puede facturar un albarán que no esté emitido ni enviado')
                } else if (this.invoiceable_type == 'budget') {
                    this.screen_data.error_message('No se puede facturar un presupuesto no aceptado')
                } else if (this.invoiceable_type == 'proforma'){
                    this.screen_data.error_message('No se puede facturar un proforma ya facturada')
                }
                return false
            }
            return true
        },
        async generateInvoiceFromInvoiceable(){
            let all_ok = this.check_can_generate_invoices()
            if (all_ok) {
                if (this.invoiceable_type == 'delivery_note' && this.screen_data.selectedItems.length > 1) {
                    this.screen_data.mergeDeliveryNotesDialog = true
                } else {
                    await this.call_generate()
                }
            }
        },
        async call_generate() {
            if (this.invoiceable_type == 'delivery_note' && this.screen_data.selectedItems.length > 1) {
                if (this.screen_data.mergeDeliveryNotesMode == 'merge') {
                    let grouped = this.screen_data.selectedItems.reduce((acc, item) => {
                        let key = `${item.sequence_id}-${item.customer.id}`
                        if (!acc[key]) {
                            acc[key] = []
                        }
                        acc[key].push(item)
                        return acc
                    }, {})
                    this.screen_data.mergeDeliveryNotesSelected = Object.values(grouped).map(group => group.map(item => item.id))
                } else {
                    this.screen_data.mergeDeliveryNotesSelected = this.screen_data.selectedItems.map(item => [item.id])
                }
            } else {
                this.screen_data.mergeDeliveryNotesSelected = this.screen_data.selectedItems.map(item => [item.id])
            }
            let order_by_invoice_number = false;
            if (this.invoiceable_type == "proforma"){
                order_by_invoice_number = true
            }
            this.screen_data.mergeDeliveryNotesDialog = false
            let res = await this.invoice_list_component.generateInvoiceFromInvoiceable(order_by_invoice_number)
            if (res) {
                await this.refreshList()
            }
        },
        async generateRemittance(){
            this.screen_data.showRemittanceTypePopUp = false;
            let res = await this.invoice_list_component.generateRemittance()
            if (res.error) {
                this.screen_data.showGenerateRemittancePopUp = true;
                this.screen_data.messageShowGenerateRemittancePopUp=res.error;
            }
        },
        showRemittancePopUp() {
            let ids = this.screen_data.selectedItems.map(item => item['id'])
            if (ids.length == 0) {
                this.screen_data.error_message('Para generar remesa debe seleccionar al menos una factura')
                return
            }
            if (this.have_payment_means_no_02()) {
                this.screen_data.showRemittancePaymentNo02Alert = true
            }
            else {
                this.screen_data.showRemittanceTypePopUp = true
            }
        },
        have_payment_means_no_02() {
            for (const item of this.screen_data.selectedItems) {
                if (item.payment_means !== "02") return true
            }
            return false
        },

        async massiveSendViaEmail(){
            // Mostrar popup inmediatamente antes de iniciar el proceso
            this.screen_data.showPopUpSuccessful = true;
            this.screen_data.messagePopUpSuccessful="El envío masivo de facturas por email puede tardar unos minutos. Puede cerrar esta pestaña, le avisaremos una vez la operación haya sido efectuada.";

            let res = await this.invoice_list_component.massiveSendViaEmail()

            // Si hubo errores, cerrar el popup de éxito y mostrar errores
            if(res && !res.success){
                this.screen_data.showPopUpSuccessful = false;
            }
        },

        async massiveSign(){
            this.screen_data.massiveSign = true
            let res = await this.invoice_list_component.massiveSign()
            if (res && res.error){
                if (res.badPaymentMeans && res.badPaymentMeans.length && res.badDueDate && res.badDueDate.length){
                    this.screen_data.dueDate=''
                    this.screen_data.paymentMeans=''
                    this.screen_data.showPopUpPaymentMeansDueDate = true;
                    this.screen_data.messagePopUpPaymentMeansDueDate=res.message + '<br>A continuación puede añadir el campo <strong>Método de pago</strong> y <strong>Fecha de Vencimiento</strong> masivamente para proceder con la firma y emisión.<br><strong>Aclaración:</strong> Solo se añadirán a las facturas cuyos campos estén vacíos, no se sobrescribirán campos ya escritos.<br><strong>Atención: Este proceso puede tardar unos minutos.</strong>';
                }
                else if (res.badPaymentMeans && res.badPaymentMeans.length){
                    this.screen_data.showPopUpPaymentMeans = true;
                    this.screen_data.messagePopUpPaymentMeans=res.message + 'A continuación puede añadir el campo <strong>Método de pago</strong> masivamente para proceder con la firma y emisión.<br><strong>Aclaración:</strong> Solo se añadirá a las facturas cuyo campo esté vacío, no se sobrescribirán campos ya escritos.<br><strong>Atención: Este proceso puede tardar unos minutos.</strong>';
                }else if(res.badDueDate && res.badDueDate.length){
                    this.screen_data.showPopUpDueDate = true;
                    this.screen_data.messagePopUpDueDate=res.message + 'A continuación puede añadir el campo <strong>Fecha de Vencimiento</strong> masivamente para proceder con la firma y emisión.<br><strong>Aclaración:</strong> Solo se añadirá a las facturas cuyo campo esté vacío, no se sobrescribirán campos ya escritos.<br><strong>Atención: Este proceso puede tardar unos minutos.</strong>';
                }else{
                    this.screen_data.showPopUp = true;
                    this.screen_data.messagePopUp=res.message;
                }
            }else if(res){
                this.screen_data.showPopUpSuccessful = true;
                this.screen_data.messagePopUpSuccessful="La firma y emisión de un gran número de facturas puede tardar unos minutos. Puede cerrar esta pestaña, le avisaremos una vez la operación haya sido efectuada.";

            }
        },


        showPaymentMeans(){
            console.log('showPaymentMeans')
            this.screen_data.massiveSign = false
            this.screen_data.paymentMeans = '' //resetejo cada cop
            this.screen_data.messagePopUpPaymentMeans=""
            this.screen_data.showPopUpPaymentMeans = true
        },

        showDueDate(){
            console.log('showDueDate')
            this.screen_data.massiveSign = false
            this.screen_data.dueDate = ''
            this.screen_data.messagePopUpDueDate=""
            this.screen_data.showPopUpDueDate = true
        },
        async massiveSignToDraft(){
            // Resetear el checkbox y mostrar el popup de confirmación
            this.delete_invoice_number = false;
            this.sign_to_draft_popup = true;
        },
        async confirmSignToDraft(){
            // Cerrar el popup
            this.sign_to_draft_popup = false;

            // Realizar la acción con el flag
            let res = await this.invoice_list_component.massiveSignToDraft(this.delete_invoice_number)
            if (res && res.error){
                console.log(res)
                this.screen_data.showPopUp = true;
                this.screen_data.messagePopUp = res.error
            }else if(res){
                this.screen_data.showPopUpSuccessful = true;
                this.screen_data.messagePopUpSuccessful="Las facturas se han pasado a borrador correctamente.";
                await this.refreshList()
            }else{
                this.screen_data.error_message('Error al pasar las facturas a borrador')
            }
        },
        // showEInvoiceTable() {
        //     console.log('showEInvoiceTable')
        //     this.
        // },

        async massivePaymentMeans(){
            console.log("massivePaymentMeans")
            this.screen_data.showPopUpPaymentMeans = false
            let res = await this.invoice_list_component.massivePaymentMeans()
            if (!this.screen_data.massiveSign){
                await this.refreshList()
            }
            if (res && res.error){
                this.screen_data.showPopUp = true;
                this.screen_data.messagePopUp = res.message
            }else if(this.screen_data.massiveSign){
                let res_sign = await this.invoice_list_component.massiveSign()
                if (res_sign && res_sign.error){
                    this.screen_data.showPopUp = true;
                    this.screen_data.messagePopUp = res_sign.message
                }
            }
        },

        async massiveDueDate(){
            this.screen_data.showPopUpDueDate = false
            let res = await this.invoice_list_component.massiveDueDate()
            if (!this.screen_data.massiveSign){
                await this.refreshList()
            }
            if (res && res.error){
                this.screen_data.showPopUp = true;
                this.screen_data.messagePopUp = res.message
            }else if(this.screen_data.massiveSign){
                let res_sign = await this.invoice_list_component.massiveSign()
                if (res_sign && res_sign.error){
                    this.screen_data.showPopUp = true;
                    this.screen_data.messagePopUp = res_sign.message
                }
            }
        },

        async massivePaymentMeansDueDate(){
            this.screen_data.showPopUpPaymentMeansDueDate = false
            let res = await this.invoice_list_component.massivePaymentMeansDueDate()

            if (res && res.error){
                this.screen_data.showPopUp = true;
                this.screen_data.messagePopUp = res.message
            }
            else{
                let res_sign = await this.invoice_list_component.massiveSign()
                if (res_sign && res_sign.error){
                    this.screen_data.showPopUp = true;
                    this.screen_data.messagePopUp = res_sign.message
                }
            }
        },

        formattedDate(date) {
            return date ? new Date(date).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'}) : '';
        },
        handleDateChange() {
            this.dateVisible = false;
            return (value) => {
                this.screen_data.externalRecInvDate = value;
            };
        },
        showInfo(item) {
            this.isActiveInfo = this.isActiveInfo === item.id ? null : item.id
        },
        toggleFilter(type) {
            this.filter_mobile_type = this.filter_mobile_type === type ? '' : type
            if (this.filter_mobile_type) {
                this.updateFilter({key: 'state', value: this.filter_mobile_type})
            } else {
                this.removeAllFilt()
            }
        },
        hideCrisp() {
            const panel = document.querySelector('.v-expansion-panel-header');

            if (panel && panel.classList.contains('v-expansion-panel-header--active')){
                window.$crisp.push(["do", "chat:hide"])
            } else {
                window.$crisp.push(["do", "chat:show"])
            }
        },
        goRecurringInvoice() {
            this.$router.push({ 'name': 'recurring-invoice-list', 'params': { 'companydb_id': this.companydb_id }})
        },
        paymentMeansToShow(code) {
            return PAYMENT_MEANS_CODE_TEXT[code] != null ? PAYMENT_MEANS_CODE_TEXT[code] : code
        },
        copyToClipboard(id) {
            navigator.clipboard.writeText(id).then(() => {
                this.screen_data.success_message('ID copiado al portapapeles');
            }).catch(err => {
                this.screen_data.error_message('Error al copiar el ID: ', err);
            });
        },
        showCustomerList() {
            this.$router.push({ name: 'invoice-customers', params: { companydb_id: this.companydb_id } });
        },
        showEmisorPopup() {
            this.$refs.popUpEmisor.openEditor();
        },
        async retryPendingEmails() {
            this.retryingEmails = true;
            try {
                const config = this.screen_data.configuration;
                console.log(config, 'Config');

                if (!config || !config.email_template || !config.email_template.subject || !config.email_template.message) {
                    this.screen_data.error_message('No hay configuración de email para este tipo de factura');
                    this.retryingEmails = false;
                    return;
                }

                // Get IDs of pending invoices
                const invoiceIds = this.pendingEmailInvoices.map(inv => inv.id);

                if (invoiceIds.length === 0) {
                    this.screen_data.error_message('No hay facturas pendientes de reenvío');
                    this.retryingEmails = false;
                    return;
                }

                // Use massive send command
                const invoice_repo = new ApiInvoiceableRepository();
                const sendingErrors = await invoice_repo.massive_send_via_email(
                    invoiceIds,
                    parseInt(this.companydb_id),
                    config.email_template
                );

                // Count results
                const errorCount = sendingErrors && typeof sendingErrors === 'object' ? Object.keys(sendingErrors).length : 0;
                const successCount = invoiceIds.length - errorCount;

                // Show results
                let message = 'Reintentos completados. ';
                if (successCount > 0) message += successCount + ' factura(s) enviadas correctamente. ';
                if (errorCount > 0) {
                    message += errorCount + ' error(es). ';
                    // Log specific errors
                    console.error('Errores de envío:', sendingErrors);
                }

                if (errorCount > 0) {
                    this.screen_data.error_message(message);
                } else {
                    this.screen_data.success_message(message);
                }

                // Close dialog and refresh invoice list after retry
                this.showPendingEmailDialog = false;
                await this.refreshList();
            } catch (error) {
                console.error('Error retrying pending emails:', error);
                const errorMsg = error.response && error.response.data && error.response.data.error
                    ? error.response.data.error
                    : error.message;
                this.screen_data.error_message('Error al reintentar envios: ' + errorMsg);
            } finally {
                this.retryingEmails = false;
            }
        },
        checkAndShowSequence2026Popup() {
            this.showSequence2026Popup = this.invoice_list_component.shouldShowSequence2026Popup(this.currentCompany)
        },
        async dismissSequence2026Popup() {
            this.dismissingPopup = true
            try {
                const success = await this.invoice_list_component.dismissSequence2026Popup(
                    parseInt(this.companydb_id),
                    this.currentCompany
                )
                if (success) {
                    this.showSequence2026Popup = false
                }
            } catch (error) {
                console.error('Error dismissing popup:', error)
                this.showSequence2026Popup = false
            } finally {
                this.dismissingPopup = false
            }
        }
    },
    computed: {
        ...mapGetters({
            got_feature: "got_feature",
            is_mobile: "is_mobile",
            userData: 'me/userData',
        }),
        ...mapState([
            'session_information',
            'currentCompany'
        ]),
        im_staff_or_loginas() {
            return (this.userData && this.userData.is_staff) || (this.session_information && this.userData.username && this.session_information.username != this.userData.username )
        },
        canCreate() {
            const isEmpty = (value) => ['', null, undefined].includes(value);
            return (
                this.screen_data.selectedItems.length == 1 ||
                this.screen_data.selectedItems.length == 0 &&
                !isEmpty(this.screen_data.externalRecInvDate) &&
                !isEmpty(this.screen_data.externalRecInvNumber)
            );
        },
        filteredHeaders(){
            return this.screen_data.invoices_headers.filter(header => {
                if (header.value === 'external_invoice_number') {
                    return this.got_feature('feature_facturae_numero_de_factura_externo')
                }
                return true
            })
        }
    },
};
</script>

<style scoped>
.accounting-link {
    text-decoration: underline;
    cursor: pointer;  /* Hace que el cursor cambie a la mano al pasar sobre él */
    font-weight: bold;
}
.accounting-link:hover {
    color: #0056b3 !important; /* Un azul más oscuro al pasar el ratón */
    text-decoration: underline;
}

::v-deep .v-card__title {
    padding-top: 15px !important;
    padding-bottom: 15px !important;

}
/*.card-title-footer-color {
    background: #fafaff;
}

::v-deep .v-data-footer {
    background-color: #fafaff;
    margin-right: 0px !important;
    padding-right: 17px;
}*/

/*fixar capçalera.*/
::v-deep .v-data-table-header>tr>th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: var(--v-primaryLight-base) !important;
}

/*fixar capçalera*/
::v-deep .v-data-table__wrapper {
  max-height: calc(100vh - 270px);
  overflow-y: auto;
}


::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}

::v-deep tbody tr:nth-of-type(even) {
    /* 'deep-orange lighten-5' basides on material design color */
    background-color: rgba(245, 245, 245, 0.47);
}

::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}

.text-field-size {
    font-weight: normal;
    font-size: 0.875rem;
}

::v-deep .input-search .v-input__slot::before {
    border-style: none !important;
}

::v-deep .input-search .v-text-field__slot,
::v-deep .input-search .v-input__prepend-inner,
::v-deep .input-search .v-input__slot {
    background-color: #f2f1ff !important;
}

::v-card-title .title-dialog {
    justify-content: space-around;
}

.autocomplete_field {
    border: solid 1px;
    border-color: var(--v-primary-base);
    color: transparent !important;
    height: 50px !important;
    margin: 0;
    padding: 0;
}

.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 36px 20px;
}

.btn-right {
    display: flex;
    justify-content: flex-end;
}

.no-underline>>>.v-text-field .v-input__control>.v-input__slot:before {
    border: none;
}
.rounded-10 {
    border-radius: 10px !important;
}

.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}

.primary_blue--text {
    color: var(--v-primary_blue-base) !important;
    font-size: 20px;
    font-weight: 600;
}
.header__menu__transaparent__btn  {
    font-family: Roboto;
    cursor: pointer;
    color: var(--v-primary_blue-base) !important;
}

.header__menu__transaparent.v-menu__content {
    margin-top: 4.1875rem;
    margin-left: 6.625rem;
    border-radius: 0px 0px 8px 8px;
}

.header__menu__options__transaparent {
    max-width: fit-content !important;
    font-size: 20px !important;
    padding-top: 0px;
}

.header__menu__options__transaparent .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
    background: rgba(var(--v-primary_blue-base-rgb), 0.1) !important;
    color: var(--v-primary_blue-base) !important;
}
.header__menu__options__transaparent .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: var(--v-primary_blue-base) !important;
}
.header__menu__options__transaparent .hover-state {
    background: rgba(var(--v-primary_blue-base-rgb), 0.1) !important;
}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
    color: var(--v-primary-base) !important;
    background: rgb(102, 51, 153, 0.1) !important;
}

.chnage__type__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    border-radius: 20px;
    gap: 8px;
    text-transform: capitalize;
}

.customer-name-mobile{
    color: #56565B;
    font-family: Roboto;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.text-mobile{
    color: #56565B;
    font-family: Roboto;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
    display: flex;
}

.state-mobile {
    background-color: #AAAAAA;
    color: white;
}

.inv-number-mobile{
    color: #888;
    text-align: right;
    font-family: Roboto;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: flex;
    justify-content: right;
}

.total-mobile{
    color: #56565B;
    text-align: right;
    font-family: Roboto;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    justify-content: right;
}

.item-padding-mobile{
    padding-left: 10px;
    padding-right: 10px;
}

.payment-state-mobile{
    color: #56565B;
    text-align: right;
    font-family: Roboto;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    justify-content: right;
}

.rounded-mobile {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}

.item-filter {
    text-transform: none !important;
}

.item-filter.v-btn--active {
    background-color: rgba(101, 55, 156, 0.3);
    border: 2px solid rgba(101, 55, 156, 1);
    border-radius: 5px;
}

.align-button-inside-mobile {
    display: flex;
    align-items: center;
}

/* Remove hover effect from pending email list */
.pending-email-list .v-list-item:hover::before {
    opacity: 0 !important;
}

.pending-email-list .v-list-item::before {
    background-color: transparent !important;
}

</style>

<style>
.config__dialog {
    scrollbar-width: thin !important;
}

.header__menu__options__transaparent .v-list-item {
    font-family: Roboto;
    font-weight: 600;
    line-height: 23.44px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    font-size: 18px !important;
    min-height: 38px !important;
    color: var(--v-primary_blue-base) !important;
}

.mobile-table-row {
    border-bottom: 3px solid rgb(237 237 237);
}

.customer-list__btn-actions {
    color: white !important;
    background-color: var(--v-primary-base) !important;
    height: 32px !important;
    padding: 0 12px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 16px !important;
    border-radius: 20px !important;
    text-transform: capitalize !important;
    margin-left: 8px !important;
}

.invoiceable-title {
    display: flex !important;
    justify-content: space-between !important; 
    align-items: center !important;             
}
.invoiceable-title_right-section {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 12px !important;
}

.clickable-icon {
    cursor: pointer !important;
    transition: opacity 0.2s !important;
}

.clickable-icon:hover {
    opacity: 0.7 !important;
}
</style>

<!--Mobile version -->
<style scoped>
.invoiceable-title-mobile {
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: white;
  display: flex !important;
  flex-direction: column;
  align-items: center;
}
.v-card__title{
    font-size: large;
}
</style>